(ns storrito.util.link
  (:require [clojure.string :as str]))

(def help-center-base-url
  #?(:cljs (if (str/ends-with? (.-hostname js/location) ".localhost")
             "http://www.storrito.localhost/help-center"
             "https://storrito.com/help-center")
     :clj "https://storrito.com/help-center"))

(defn help-center-url
  ([] (str help-center-base-url "/"))
  ([article-id] (str help-center-base-url "/" article-id "/")))

(def changelog-url
  "The public changelog on the website."
  #?(:cljs (if (str/ends-with? (.-hostname js/location) ".localhost")
             "http://www.storrito.localhost/changelog/"
             "https://storrito.com/changelog/")
     :clj "https://storrito.com/changelog/"))

(def invalid-url-helpcenter-article
  (help-center-url "5c083c02-30ef-4410-b900-bfc922b44e61"))

;; Concept:
;; Gather knowledge on IG hyperlinks (both swipe up and link stickers)
;; Have validity, transformations, parameter for it.
;; Usefull for uniformity accross the app, front and backend, editor and publishing view, ...

;; Validated on 28th of December 2021
(def ig-link-max-length 245)

(defn normalized-url
  "The link url as `valid-url` posts it, before its cut at
   `ig-link-max-length`: trimmed, inner spaces as %20, other Unicode
   spaces removed."
  [url]
  (-> url
      ;; trim url
      (str/trim)
      ;; Replaces blanks  with %20 (utf-8 encoded space character)
      (str/replace " "
                   "%20")
      ;; Replaces all occurrences of Unicode whitespace characters with an empty string.
      ;; For example the common &NBSP character
      (str/replace #"\p{Zs}" "")))

;; TODO Add a deftest to check if valid-url of a nul string
(defn valid-url
  "Converts the link url to a valid URL that works on Instagram.
   A valid url must not contain leading, trailing or black spaces in between.
   And the url must be shorter than 246 characters. (Validated on 28th of December).
   Otherwise, the link stickers are not clickable."
  [url]
  (when url
    (let [trimmed-url (normalized-url url)]
      (subs trimmed-url
            0
            (min (count trimmed-url)
                 ig-link-max-length
                 )))))

(defn too-long?
  "The url must be shorter than 246 characters. (Validated on 28th of December).
   Otherwise, the link stickers are not clickable."
  [url]
  (> (count url)
     ig-link-max-length
     ))

(defn validate-weblink?
  "Returns true if ´weblink´ is blank string or is a weblink.
   This means: Starts with http:// or https://
   followed by char/number sequence
   followed by . char sequece
   followed by url query"
  [weblink]
  (or (str/blank? weblink)
      (str/starts-with? weblink "http://")
      (str/starts-with? weblink "https://")))

(defn contains-whitespaces?
  "Tells if your url contains whitespaces"
  [url]
  (if (nil? url)
    false
    (str/includes? url " ")))
(comment
  (contains-whitespaces? "")
  (contains-whitespaces? "http://www.google.fr")
  (contains-whitespaces? " ")
  (contains-whitespaces? "http://www. google.fr")
  (contains-whitespaces? "http://w ww.g oogle.fr")
  (contains-whitespaces? "http://w ww.g oogle.fr ")
  )

;;TODO add deftest for null url
(defn is-valid?
  "Gather all conditions for a link to be valid"
  [url]
  (and (not (too-long? url))
       (validate-weblink? url)
       (not (contains-whitespaces? url))))
